import React from 'react';
import PropTypes from 'prop-types';
import Component from 'BaseComponent';

export default class SubmitButton extends Component {
  static propTypes = {
    submitting: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    dirty: PropTypes.bool.isRequired,
    className: PropTypes.string,
  };

  render() {
    const { submitting, dirty, className, label } = this.props;
    return (
      <button
        className={className}
        disabled={submitting || !dirty}
      >
        {
          submitting ?
            this.t('Button.pleaseWait') :
            this.t(label)
        }
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./app/form/SubmitButton.jsx